import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const DotAuditSection = Loadable(lazy(() => import('./DotAuditSection')));
const DotAuditRoutes = [
	{
		path: '/dotaudit',
		element: <DotAuditSection />,
		auth: authRoles.admin,
	},
];

export default DotAuditRoutes;
